import { render, staticRenderFns } from "./NearbyDestinations.vue?vue&type=template&id=244c54dc&scoped=true"
import script from "./NearbyDestinations.vue?vue&type=script&lang=js"
export * from "./NearbyDestinations.vue?vue&type=script&lang=js"
import style0 from "./NearbyDestinations.vue?vue&type=style&index=0&id=244c54dc&prod&scoped=true&lang=css"
import style1 from "./NearbyDestinations.vue?vue&type=style&index=1&id=244c54dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c54dc",
  null
  
)

export default component.exports